module.exports = __webpack_public_path__ + "static/img/news29_6.ca5b21c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news29/news29_6.jpeg
// module id = K4zg
// module chunks = 0